import { createSelector } from 'reselect';
import ThresholdsForCertificationDetailsColumns from '../../containers/ThresholdsForCertificationDetailsColumns';
import ReportDefinitions from '../../../../../../common/config/ReportDefinitions';

export const getGeneratedOnDateTime = state => state
  .reporting.THRESHOLDS_FOR_CERTIFICATION_545_DETAILS.metadata.generatedOnDateTime;

export const getIsLoading =
  state => state.reporting.THRESHOLDS_FOR_CERTIFICATION_545_DETAILS.isLoading;

export const getData =
  ReportDefinitions.THRESHOLDS_FOR_CERTIFICATION_545_DETAILS.getDataFunction();

export const getColumns =
  createSelector(getData, ThresholdsForCertificationDetailsColumns);
